import { Component, OnInit, Output, EventEmitter, ViewChild, Input } from '@angular/core';
import { KmsService } from '../../kms.service';
import { SwMassageBoxService } from '../../../../librarys/serves/sw-massage-box.service';
import { SwModalframeComponent } from 'src/app/librarys/components/basic-components/sw-modal-frame/sw-modal-frame.component';
import { SwJwtService } from '../../../../librarys/serves/sw-jwt.service';
import { InstanceModuleService } from '../../serves/instance/instance.module';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { KmsEnum } from '../../serves/kms-enum';
declare var $;

@Component({
  selector: 'app-edit-datasource',
  templateUrl: './edit-datasource.component.html',
  styleUrls: ['./edit-datasource.component.css']
})
export class EditDatasourceComponent implements OnInit {

    @ViewChild('datasourceModal') datasourceModal: SwModalframeComponent;
    // 输入参数
    @Input() param: any;
    // 抛出事件
    @Output() callback = new EventEmitter();
    // 状态：edit、view
    state:string = 'view';
    //  数据来源信息,用于父组件做数据回显
    echoDatas:any = [];
    // 待删除的来源
    deleteIds:any = [];
    // 是否展示添加\编辑来源模块
    showAddSource = false;
    // 添加问题记录信息
    formModel:any = {}
    // 是否展示素材列表
    showMaterials = false;
    keyword = '';
    materialList = [];
    // 是否展示来源图片及文字
    showSource = false;
    selectSource:any = {};
    filePath:string = '';
    // 当前是新增还是编辑一条来源数据
    upOrAdd:string = 'add';
    materialCategory = "FILE_TYPE_DOCUMENT";
    fileCategoryOptions = [];
    
    constructor(
        private router: Router,
        private instanceModuleService: InstanceModuleService,
        private kmsService: KmsService,
        private message: SwMassageBoxService,
        private jwt: SwJwtService,
    ) { }

    ngOnInit() {
      this.fileCategoryOptions = [{ id: "FILE_TYPE_ALL", text: "全部" }];
      this.fileCategoryOptions = this.fileCategoryOptions.concat(
        this.instanceModuleService.getResourceTypeOptions()
      );
      this.state = this.param.state;
      this.echoDatas = JSON.parse(JSON.stringify(this.param.sourceList ? this.param.sourceList : []));
      this.echoDatas.forEach(element => {
        // 定义一个唯一标识用于区分编辑和删除
        element['sourceId']=this.instanceModuleService.uuid2();
        element.pageNum = element.pageNum && element.pageNum > 0 ? element.pageNum : null;
        element.relPageNum = element.relPageNum && element.relPageNum > 0 ? element.relPageNum : null;
        element.sourceMaterial = element.sourceMaterial && element.sourceMaterial !== 'null' ? element.sourceMaterial : '';
        element.sourceText = element.sourceText && element.sourceText !== 'null' ? element.sourceText : '';
        element.datasource = element.datasource && element.datasource !== 'null' ? element.datasource : '';
      });
      this.deleteIds = [];
      this.showAddSource = false;
      this.formModel = {};
    }

    // 新增来源
    addSource(){
      this.upOrAdd = 'add';
      this.showAddSource =  true;
      let data = this.jwt.getToken('materialTextSelect') ? JSON.parse(this.jwt.getToken('materialTextSelect')) : null;
      if(data){
        this.formModel = {
          "uuid": '',
          "sourceId": this.instanceModuleService.uuid2(),
          "materialId": data.materialId,
          "sourceText":data.sourceText,
          "sourceMaterial":data.sourceMaterial,
          "pageNum":data.pageNum,
          "relPageNum":data.relPageNum,
          "datasource":data.datasource
        }
      }else{
        this.formModel = {
          "uuid": '',
          "sourceId": this.instanceModuleService.uuid2(),
          "materialId":'',
          "sourceText":'',
          "sourceMaterial":'',
          "pageNum":null,
          "relPageNum":null,
          "datasource":''
        }
      }
      this.jwt.setToKen('materialTextSelect','');
    }

    // 编辑来源
    editSource(i){
      this.formModel = JSON.parse(JSON.stringify(this.echoDatas[i]));
      this.upOrAdd = 'edit';
      this.showAddSource = true;
    }

    // 删除来源
    deleteSource(i){
      if(this.echoDatas[i].uuid){
        this.deleteIds.push(this.echoDatas[i].uuid);
      }
      this.echoDatas.splice(i,1);
    }

    // 查看来源
    viewSource(child){
      this.showSource = true;
      // 查询当前页数据
      this.kmsService.queryByDetailId(
        {
          "pageNum": child.pageNum,
          "materialId": child.materialId
        }
      ).subscribe(
        data => {
          if (data.code == '200') {
            this.selectSource = data.data;
            if(this.selectSource && this.selectSource.materialText){
              this.filePath = data.data.filePath;
              if(child.sourceText){
                let keyword = child.sourceText;
                this.selectSource.materialText = this.selectSource.materialText.replace(new RegExp(keyword,'g')  ,'<i class="gaoliang">'+keyword+'</i>');                  
              }
            }
          }
        }
      );
    }

    // 保存、更新问题记录
    onSubmit({ value, valid }, event: Event) {
      if (valid) {
        if(!this.formModel.sourceText){
          this.message.danger('请录入来源文本！');
          return;
        }
        let isAdd = true;
        for(let i=0;i<this.echoDatas.length;i++){
          if(this.echoDatas[i].sourceId == this.formModel.sourceId){
            this.echoDatas[i] = JSON.parse(JSON.stringify(this.formModel));
            isAdd = false;
            break;
          }
        }
        if(isAdd){
          this.echoDatas.unshift(this.formModel);
        }
        this.showAddSource = false;
      }
    }

    toggleMaterial(state){
      this.showMaterials = state;
    }

    setMaterial(item){
      this.formModel.materialId = item.materialId;
      this.formModel.sourceMaterial = item.materialTitle;
      this.showMaterials = false;
    }

    //enter键触发搜索
    enterSearch(event) {
      if (event.keyCode == '13') {
        this.searchMaterial();
      }
    }

    searchMaterial(){
      let keyword = $.trim(this.keyword);
      if(!keyword){
        this.message.danger('请输入素材名称！');
        return;
      }
      let params = {
        current: 1,
        size: 30,
        materialTitle: keyword,
        materialCategory: this.materialCategory == 'FILE_TYPE_ALL' ? '' : this.materialCategory
      }
      this.kmsService.queryMaterialList(params).subscribe(
        data => {
          if (data.code == '200') {
            this.materialList = data.data.records ? data.data.records : [];
          } else {
            console.log(data.msg);
          }
        }
      );
    }

    clear(){
      this.formModel.materialId = '';
      this.formModel.sourceMaterial = '';
    }

    emitFunc(){
      this.datasourceModal.toggle();
      this.callback.emit({
        'data': this.echoDatas,
        'deleteIds': this.deleteIds
      });
    }

    // 进入数据资源内容编辑页面
    clickView(data){
      if(data.materialId){
        this.datasourceModal.toggle();
        this.callback.emit({
          'data': this.echoDatas,
          'deleteIds': this.deleteIds
        });
        let params = {
          materialId: data.materialId,
          keyword: '',
          current: data.pageNum ? data.pageNum : 1
        };
        this.router.navigate(['/kms/KnowledgeExtract'], {queryParams: {Title: '素材浏览', selectData: JSON.stringify(params)}});
      }
    }
}
